export const PASSWORD_INVALID_ERROR_KEY = 'password_invalid';
export const PASSWORD_REQUIRED_ERROR_KEY = 'password_required';

export const INVALID_IDENTIFIER_ERROR_KEY = 'invalid';
export const INVALID_EMAIL_ERROR_KEY = 'invalid_email';
export const INVALID_MSISDN_ERROR_KEY = 'invalid_msisdn';
export const LOGIN_ID_STORAGE_ITEM_KEY = 'login-id';
